import {
  OpportunityCardData,
  OpportunityLabel,
  AudienceType,
  DeliveryMode,
  SkillType,
  OpportunityStatus
} from './opportunity-card/opportunity-card.component';


export const OPPORTUNITIES_DATA: OpportunityCardData[] = [
  // Cal Poly Pomona Resources
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Site',
    description: 'Explore all career center resources, book appointments and get support',
    source: 'Cal Poly Pomona',

    id: 'CalPoly-1',
    campus: 'Cal Poly Pomona',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Career Planning', 'Goal Setting'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.cpp.edu/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Handshake',
    description: 'Find and apply for jobs and internships',
    source: 'Cal Poly Pomona',

    id: 'CalPoly-2',
    campus: 'Cal Poly Pomona',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Job Search', 'Internship'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.cpp.edu/channels/handshake-101/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Events',
    description: 'Discover upcoming career fairs and workshops',
    source: 'Cal Poly Pomona',

    id: 'CalPoly-3',
    campus: 'Cal Poly Pomona',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'in-person' as DeliveryMode,
    skillTags: ['Networking', 'Career Exploration'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.cpp.edu/employer-engagement-opportunities/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Digital Career Resources',
    description: 'Access online tools and guides to build your career skills',
    source: 'Cal Poly Pomona',

    id: 'CalPoly-4',
    campus: 'Cal Poly Pomona',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Career Planning', 'Skill Building'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.cpp.edu/channels/digital-career-resources/'
  },

  // CSU Dominguez Hills Resources
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Site',
    description: 'Explore all career center resources, book appointments and get support.',
    source: 'CSU Dominguez Hills',

    id: 'DH-1',
    campus: 'CSU Dominguez Hills',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Career Planning', 'Goal Setting'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csudh.edu/career-center/'
  },
  {
    label: 'Academic Support',
    labelType: 'academic-support' as OpportunityLabel,
    title: 'Career & Academic Advising Appointments',
    description: 'Schedule advising sessions through the Toro Success Collaborative (TSC)',
    source: 'CSU Dominguez Hills',

    id: 'DH-2',
    campus: 'CSU Dominguez Hills',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Academic Planning', 'Career Advising'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://my.csudh.edu/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Digital Career Toolkit',
    description: "Access CSUDH's online tools and career resources",
    source: 'CSU Dominguez Hills',

    id: 'DH-3',
    campus: 'CSU Dominguez Hills',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Career Planning', 'Skill Building'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csudh.edu/career-center/digital-career-toolkit'
  },

  // CSU Fullerton Resources
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Site',
    description: 'Explore all career center resources, book appointments, and get support',
    source: 'CSU Fullerton',

    id: 'Fullerton-1',
    campus: 'CSU Fullerton',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Career Planning', 'Goal Setting'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.fullerton.edu/career/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Handshake',
    description: 'Search for jobs and internships',
    source: 'CSU Fullerton',

    id: 'Fullerton-2',
    campus: 'CSU Fullerton',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Job Search', 'Internship'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://business.fullerton.edu/career-services/job-resources'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Events',
    description: 'Discover workshops, info sessions and other career events',
    source: 'CSU Fullerton',

    id: 'Fullerton-3',
    campus: 'CSU Fullerton',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Networking', 'Career Exploration'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.fullerton.edu/career/students/workshops-info-sessions.html'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Hiration',
    description: 'Build and polish your resume with this guided tool',
    source: 'CSU Fullerton',

    id: 'Fullerton-4',
    campus: 'CSU Fullerton',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Resume Building', 'Writing'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.fullerton.edu/career/students/hiration/hiration.html'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Assessments',
    description: 'Explore your strengths and interests with career assessments',
    source: 'CSU Fullerton',

    id: 'Fullerton-5',
    campus: 'CSU Fullerton',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Self-Assessment', 'Career Exploration'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.fullerton.edu/career/students/career-major-exploration/assessments.html'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Interview Prep',
    description: 'Get tips and tools to prepare for interviews',
    source: 'CSU Fullerton',

    id: 'Fullerton-6',
    campus: 'CSU Fullerton',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Interview Skills', 'Communication'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.fullerton.edu/career/students/interviewing/index.html'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Titan Connection',
    description: 'Search for jobs and internships open to all CSUF students',
    source: 'CSU Fullerton',

    id: 'Fullerton-7',
    campus: 'CSU Fullerton',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Job Search', 'Internship'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://apps.fullerton.edu/career'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Fairs',
    description: 'Find upcoming career fairs and networking events',
    source: 'CSU Fullerton',

    id: 'Fullerton-8',
    campus: 'CSU Fullerton',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'in-person' as DeliveryMode,
    skillTags: ['Networking', 'Career Exploration'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.fullerton.edu/career/events/career-fairs-expos.html'
  },

  // Cal State LA Resources
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Site',
    description: 'Explore all career center resources, book appointments, and get support',
    source: 'Cal State LA',

    id: 'LA-1',
    campus: 'Cal State LA',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Career Planning', 'Goal Setting'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.calstatela.edu/careercenter'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Handshake',
    description: 'Find and apply for jobs and internships',
    source: 'Cal State LA',

    id: 'LA-2',
    campus: 'Cal State LA',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Job Search', 'Internship'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.calstatela.edu/careercenter/cal-state-la-handshake'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Focus2',
    description: 'Discover careers that match your interests and strengths',
    source: 'Cal State LA',

    id: 'LA-3',
    campus: 'Cal State LA',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Self-Assessment', 'Career Exploration'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.calstatela.edu/careercenter/focus2'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Events',
    description: 'Learn about upcoming career fairs, workshops and events',
    source: 'Cal State LA',

    id: 'LA-4',
    campus: 'Cal State LA',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Networking', 'Career Exploration'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.calstatela.edu/careercenter/career-events'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Future First',
    description: 'Explore career paths and plan your next steps with this guide',
    source: 'Cal State LA',

    id: 'LA-5',
    campus: 'Cal State LA',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Career Planning', 'Goal Setting'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.calstatela.edu/careercenter/future-first'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Resume Resource',
    description: 'Create strong resumes and cover letters that stand out',
    source: 'Cal State LA',

    id: 'LA-6',
    campus: 'Cal State LA',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Resume Building', 'Writing'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.calstatela.edu/careercenter/resume-and-letter-builder'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Parker Dewey',
    description: 'Gain experience through short-term micro-internships',
    source: 'Cal State LA',

    id: 'LA-7',
    campus: 'Cal State LA',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Internship', 'Experience'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://info.parkerdewey.com/student/calstatela'
  },

  // CSU Long Beach Resources
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Site',
    description: 'Explore all career center resources, book appointments, and get support',
    source: 'CSU Long Beach',

    id: 'LB-1',
    campus: 'CSU Long Beach',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Career Planning', 'Goal Setting'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csulb.edu/career-development-center'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Handshake',
    description: 'Find and apply for jobs and internships',
    source: 'CSU Long Beach',

    id: 'LB-2',
    campus: 'CSU Long Beach',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Job Search', 'Internship'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'inactive' as OpportunityStatus,
    link: ''
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Focus2',
    description: 'Discover careers that fit your interests and strengths',
    source: 'CSU Long Beach',

    id: 'LB-3',
    campus: 'CSU Long Beach',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Self-Assessment', 'Career Exploration'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'inactive' as OpportunityStatus,
    link: ''
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Events',
    description: 'Learn about upcoming career fairs, workshops, and other events',
    source: 'CSU Long Beach',

    id: 'LB-4',
    campus: 'CSU Long Beach',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Networking', 'Career Exploration'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csulb.edu/career-development-center/students/student-events-workshops'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Job Scan',
    description: 'Get personalized feedback to improve your resume',
    source: 'CSU Long Beach',

    id: 'LB-5',
    campus: 'CSU Long Beach',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Resume Building', 'Writing'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csulb.edu/career-development-center/students/resumes-cover-letters'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Links to Job Search',
    description: 'Access job search tools and tips',
    source: 'CSU Long Beach',

    id: 'LB-6',
    campus: 'CSU Long Beach',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Job Search', 'Career Planning'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csulb.edu/career-development-center/students/job-internship-search'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Link',
    description: 'Log in to view campus job listings and career resources',
    source: 'CSU Long Beach',

    id: 'LB-7',
    campus: 'CSU Long Beach',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Job Search', 'Campus Jobs'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://csulb-csm.symplicity.com/students/?signin_tab=0'
  },

  // CSU Northridge Resources
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Site',
    description: 'Explore all career center resources, find drop-in times, and schedule appointments',
    source: 'CSU Northridge',

    id: 'Northridge-1',
    campus: 'CSU Northridge',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Career Planning', 'Goal Setting'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csun.edu/career'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Handshake',
    description: 'Search for on- and off-campus jobs and internships',
    source: 'CSU Northridge',

    id: 'Northridge-2',
    campus: 'CSU Northridge',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Job Search', 'Internship'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://csun.joinhandshake.com/login'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Events',
    description: 'Discover upcoming career fairs, workshops, and events',
    source: 'CSU Northridge',

    id: 'Northridge-3',
    campus: 'CSU Northridge',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Networking', 'Career Exploration'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://news.csun.edu/organizer/career-center/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Resume guidance',
    description: 'Learn how to improve your resume and cover letter',
    source: 'CSU Northridge',

    id: 'Northridge-4',
    campus: 'CSU Northridge',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Resume Building', 'Writing'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csun.edu/career/services/resume-cover-letter-cv'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'CareerLink',
    description: "Access CSUN's academic and career planning resources in one place",
    source: 'CSU Northridge',

    id: 'Northridge-5',
    campus: 'CSU Northridge',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Career Planning', 'Academic Planning'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csun.edu/careerlink/'
  },

  // CSU San Bernardino Resources
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Site',
    description: 'Explore career center resources, book appointments, and get support',
    source: 'CSU San Bernardino',

    id: 'SB-1',
    campus: 'CSU San Bernardino',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Career Planning', 'Goal Setting'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csusb.edu/career-center'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Coyote Careers',
    description: 'Find and apply for jobs and internships through Coyote Careers',
    source: 'CSU San Bernardino',

    id: 'SB-2',
    campus: 'CSU San Bernardino',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Job Search', 'Internship'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csusb.edu/career-center/coyote-careers-powered-handshake'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Focus2',
    description: 'Discover careers that match your interest and goals',
    source: 'CSU San Bernardino',

    id: 'SB-3',
    campus: 'CSU San Bernardino',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Self-Assessment', 'Career Exploration'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'inactive' as OpportunityStatus,
    link: ''
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Events',
    description: 'Learn about upcoming career fairs, workshops and other events',
    source: 'CSU San Bernardino',

    id: 'SB-4',
    campus: 'CSU San Bernardino',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Networking', 'Career Exploration'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csusb.edu/career-center/events'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Resume resources',
    description: 'Get tips and examples to build a strong resume or cover letter',
    source: 'CSU San Bernardino',

    id: 'SB-5',
    campus: 'CSU San Bernardino',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Resume Building', 'Writing'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2025-10-31',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csusb.edu/career-center/students/career-resources/resumes-cover-letters-cvs'
  },

  // American University Resources
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'AU Career Center - Main Page',
    description: "Students and alumni's go-to source for the latest updates on career events, fairs, job collections, programs, networking opportunities, news, alerts, and more.",
    source: 'American University',

    id: 'AU-1',
    campus: 'American University',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Career Planning', 'Goal Setting'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2026-02-02',
    status: 'active' as OpportunityStatus,
    link: 'https://www.american.edu/careercenter/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'AU Career Center Advising Appointments',
    description: 'Explore career advising options and find the best match for your education stage, school, and professional interests.',
    source: 'American University',

    id: 'AU-2',
    campus: 'American University',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'hybrid' as DeliveryMode,
    skillTags: ['Career Advising', 'Career Planning'],
    skillType: 'durable' as SkillType,
    priorityLevel: 1,
    lastUpdated: '2026-02-02',
    status: 'active' as OpportunityStatus,
    link: 'https://www.american.edu/careercenter/advising-appointments.cfm'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Resume Examples and Templates',
    description: 'Tailor your resume to the specific position for which you are applying and present your most relevant skills, experience, and achievements.',
    source: 'American University',

    id: 'AU-3',
    campus: 'American University',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Resume Building', 'Writing'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2026-02-02',
    status: 'active' as OpportunityStatus,
    link: 'https://www.american.edu/careercenter/resumes.cfm'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Exploration & Self-Assessments',
    description: 'Guidelines designed to support students experiencing uncertainty about academic majors or career paths, changing interests, and unclear next steps.',
    source: 'American University',

    id: 'AU-4',
    campus: 'American University',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Self-Assessment', 'Career Exploration'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2026-02-02',
    status: 'active' as OpportunityStatus,
    link: 'https://www.american.edu/careercenter/self-assessment-and-exploration.cfm'
  },
  {
    label: 'Skill Builder',
    labelType: 'skill-builder' as OpportunityLabel,
    title: 'Prepare for Success with Career Readiness Competencies',
    description: 'Learn what career readiness competencies are, how to build them, and how to highlight them to employers.',
    source: 'American University',

    id: 'AU-5',
    campus: 'American University',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Skill Building', 'Career Readiness'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2026-02-02',
    status: 'active' as OpportunityStatus,
    link: 'https://www.american.edu/careercenter/prepare-for-success.cfm'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Federal Hiring: News and Resources',
    description: 'Support for students and alumni navigating internship and job loss or uncertainty. Explore the events and resources below to explore options, build networks, and prepare job search materials.',
    source: 'American University',

    id: 'AU-6',
    campus: 'American University',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Job Search', 'Networking'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2026-02-02',
    status: 'active' as OpportunityStatus,
    link: 'https://www.american.edu/careercenter/federal-hiring-news-and-resources.cfm'
  },
  {
    label: 'Skill Builder',
    labelType: 'skill-builder' as OpportunityLabel,
    title: 'AI in Your Career Development',
    description: 'Practical tips and specific examples for how to use AI in different aspects of your career development.',
    source: 'American University',

    id: 'AU-7',
    campus: 'American University',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['AI', 'Skill Building'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2026-02-02',
    status: 'active' as OpportunityStatus,
    link: 'https://www.american.edu/careercenter/ai-in-your-career-development.cfm'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Online Career Resources',
    description: 'Online resources designed to support career development, whether exploring career options, beginning a job search, or preparing for interviews.',
    source: 'American University',

    id: 'AU-8',
    campus: 'American University',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Career Planning', 'Job Search'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2026-02-02',
    status: 'active' as OpportunityStatus,
    link: 'https://www.american.edu/careercenter/online-resources.cfm'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Fraudulent Jobs and Internship Postings',
    description: 'Resources to help identify and avoid fraudulent job or internship opportunities, and what to do if you are affected.',
    source: 'American University',

    id: 'AU-9',
    campus: 'American University',
    careerArea: ['Business', 'STEM', 'Arts', 'Health'],
    audienceType: ['all' as AudienceType],
    timing: 'Ongoing',
    deliveryMode: 'online' as DeliveryMode,
    skillTags: ['Job Search', 'Safety'],
    skillType: 'durable' as SkillType,
    priorityLevel: 2,
    lastUpdated: '2026-02-02',
    status: 'active' as OpportunityStatus,
    link: 'https://www.american.edu/careercenter/fraudulentjobs.cfm'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Development Center Website',
    description: 'To schedule an appointment, please call 559-278-2381 or email css1@mail.fresnostate.edu',
    source: 'Fresno',

    id: 'Fresno-1',
    campus: 'Fresno State University',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.fresnostate.edu/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Quinncia',
    description: 'An AI enabled resume and LinkedIn review and mock interview platform that\'s free to current Fresno State junior, senior and graduate students.',
    source: 'Fresno',

    id: 'Fresno-2',
    campus: 'Fresno State University',
    status: 'active' as OpportunityStatus,
    link: 'https://cdn.uconnectlabs.com/wp-content/uploads/sites/191/2026/01/quinncia-handout.pdf'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Development Center Events and Workshops',
    description: 'Attend events to explore careers, connect with employers/alumni, and build confidence to launch your career.',
    source: 'Fresno',

    id: 'Fresno-3',
    campus: 'Fresno State University',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.fresnostate.edu/events/?ctag%5B0%5D=career-fairs&ctag%5B1%5D=featured-events&ctag%5B2%5D=info-sessions&ctag%5B3%5D=networking-events&ctag%5B%5D=workshops'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'HireFresnoState',
    description: 'Fresno State\'s On-Line Job and Internship Opportunity System',
    source: 'Fresno',

    id: 'Fresno-4',
    campus: 'Fresno State University',
    status: 'active' as OpportunityStatus,
    link: 'http://fresnostate.12Twenty.com'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Personalized Career Counseling',
    description: 'Meet with a career counselor to turn your results into an actionable career plan.',
    source: 'San Jose State',

    id: 'SJSU-1',
    campus: 'San Jose State University',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.sjsu.edu/resources/career-counseling-appointments/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Real-Time Career Data (Labor Market Insights)',
    description: 'Research real-time data on job trends, employers, and salaries by region.',
    source: 'San Jose State',

    id: 'SJSU-2',
    campus: 'San Jose State University',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.sjsu.edu/labor-market-insights/'
  },
  {
    label: 'Skill Development',
    labelType: 'skill-development' as OpportunityLabel,
    title: 'Build Skills (LinkedIn Learning)',
    description: 'Build high-demand skills through free courses.',
    source: 'San Jose State',

    id: 'SJSU-3',
    campus: 'San Jose State University',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.sjsu.edu/resources/linkedin-learning/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Instant Resume Feedback (VMock)',
    description: 'Craft and improve your resume with instant, personalized feedback',
    source: 'San Jose State',

    id: 'SJSU-4',
    campus: 'San Jose State University',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.sjsu.edu/resources/vmock/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Targeted Job & Internship Search (SJSU Handshake)',
    description: 'Find and apply for jobs and internships.',
    source: 'San Jose State',

    id: 'SJSU-5',
    campus: 'San Jose State University',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.sjsu.edu/resources/sjsu-handshake/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career-Focused Events & Workshops',
    description: 'Attend events to explore careers, connect with employers/alumni, and build confidence to launch your career.',
    source: 'San Jose State',

    id: 'SJSU-6',
    campus: 'San Jose State University',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.sjsu.edu/events/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Quick Career Guides (Templates & Examples)',
    description: 'Use step-by-step guides and templates to build your resume, prepare for interviews, and apply with confidence.',
    source: 'San Jose State',

    id: 'SJSU-7',
    campus: 'San Jose State University',
    status: 'active' as OpportunityStatus,
    link: 'https://careercenter.sjsu.edu/resources/career-guides/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Advising Appointments',
    description: 'Meet one-on-one with a Career Counselor to explore career paths, review your resume, and get personalized guidance on your job or internship search.',
    source: 'San Marcos',

    id: 'SM-1',
    campus: 'CSU San Marcos',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csusm.edu/careers/career_counseling.html'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Find Jobs & Internships on Handshake',
    description: 'Search and apply for jobs and internships, register for events, and connect with employers using CSUSM’s career platform.',
    source: 'San Marcos',

    id: 'SM-2',
    campus: 'CSU San Marcos',
    status: 'active' as OpportunityStatus,
    link: 'https://csusm.joinhandshake.com/'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Resources & Tools',
    description: 'Access resume guides, interview preparation tools, and online resources to help you build your career readiness skills.',
    source: 'San Marcos',

    id: 'SM-3',
    campus: 'CSU San Marcos',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csusm.edu/careers/cc_online_resources/index.html'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Events & Workshops',
    description: 'Attend career fairs, workshops, and networking events to connect with employers and build your professional skills.',
    source: 'San Marcos',

    id: 'SM-4',
    campus: 'CSU San Marcos',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csusm.edu/careers/events.html'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Explore Internships',
    description: 'Learn how to find and secure internships to gain hands-on experience and strengthen your career pathway.',
    source: 'San Marcos',

    id: 'SM-5',
    campus: 'CSU San Marcos',
    status: 'active' as OpportunityStatus,
    link: 'https://www.csusm.edu/careers/internships/index.html'
  },
  {
    label: 'Career Support',
    labelType: 'career-support' as OpportunityLabel,
    title: 'Career Center Site',
    description: 'Explore all career center resources, book appointments, and get support',
    source: 'ETS',

    id: 'SLO-1',
    campus: 'Cal Poly San Luis Obispo',
    status: 'active' as OpportunityStatus,
    link: 'https://careerservices.calpoly.edu/home'
  }
].sort((a, b) => a.title.localeCompare(b.title)); // Sort alphabetically by title
